// extracted by mini-css-extract-plugin
export default {"menuMobile":"SettingsTopMenu_menuMobile__rwwkz","menuDesktop":"SettingsTopMenu_menuDesktop__vH2ix"};